import { ROUTES } from '@/features/core/container';
import { option } from '@/util/container';
import { component } from '../component';
import { APP_HELP } from './app.builder';

export default option(ROUTES, async () => {
  return [
    {
      path: '/help',
      component: component('views/app/AppView.vue'),
      meta: { app: APP_HELP },
      children: [
        {
          path: '/help',
          name: 'AppHelp',
          beforeEnter: (to, from, next) => next({ name: 'AppHelp/ContactForm' }),
        },
        {
          path: 'contact-form',
          name: 'AppHelp/ContactForm',
          component: component('views/app/contact-form/ContactFormView.vue'),
          meta: { app: APP_HELP },
        },
        {
          path: 'faq',
          name: 'AppHelp/Faq',
          component: component('views/app/faq/FaqView.vue'),
          meta: { app: APP_HELP },
        },
      ],
    },
  ];
});
